import { render, staticRenderFns } from "./land-contract-template.html?vue&type=template&id=1fae021d&scoped=true&external"
import script from "./land-contract-template.js?vue&type=script&lang=js&external"
export * from "./land-contract-template.js?vue&type=script&lang=js&external"
import style0 from "./land-contract-template.scss?vue&type=style&index=0&id=1fae021d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae021d",
  null
  
)

export default component.exports